import { render, staticRenderFns } from "./RiskAssessment.vue?vue&type=template&id=6e3c1a1a&scoped=true"
import script from "./RiskAssessment.vue?vue&type=script&lang=js"
export * from "./RiskAssessment.vue?vue&type=script&lang=js"
import style0 from "./RiskAssessment.vue?vue&type=style&index=0&id=6e3c1a1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c1a1a",
  null
  
)

export default component.exports